import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { TemplateForm } from './edit-template.dto';
@Injectable({
    providedIn: 'root'
})

export class EditTemplateService {

    constructor(
        private http: HttpClient,
    ) { }



   
   
    /**
     * Retrieves a template by its ID and checks the user's access level for the template.
     * If the user does not have the required access level, an error message is displayed
     * and the user is redirected to the templates page.
     *
     * @param {number} id - The ID of the template to retrieve.
     * @returns {Observable<ITemplateWithAccessLevel>} An observable that emits the template and the user's access level.
     */
    getTemplate(id: number): Observable<TemplateForm> {
        return this.http.get<TemplateForm>(`templates/${id}`);
    }


    
    /**
     * Updates an existing template with the provided form data.
     *
     * @param {TemplateForm} form - The form data containing the template information to be updated.
     * @returns {Observable<any>} An observable that emits the response from the HTTP PUT request.
     */
    updateTemplate(form: TemplateForm) {
        return this.http.put(`templates/${form.template?.id}`, form);
    }

    
    /**
     * Adds a role to a template.
     *
     * @param formData - An object containing the template ID.
     * @returns An Observable of the HTTP POST request.
     */
    addTemplateRole(formData: { template_id: number }) {
        return this.http.post(`templates/${formData.template_id}/template-role`, formData);
    }




   
    /**
     * Uploads a PDF file and converts it to an image for a specific template.
     *
     * @param {number} template_id - The ID of the template to which the PDF belongs.
     * @param {FormData} formData - The form data containing the PDF file to be uploaded.
     * @returns {Observable<any>} An observable containing the server's response.
     */
    uploadPdf(template_id: number, formData) {
        return this.http.post(`templates/${template_id}/pdf-to-image`, formData);
    }

    getCountry(){
        return this.http.get('geoip');
    }
}
